import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import TariffItemTierForRecalTablePanel from "./Edit/TariffItemTierForRecalTablePanel";
import ProposalCopyingForRecalTariffItemTablePanel from "./Table/ProposalCopyingForRecalTariffItemTablePanel";
import TariffItemCopyForRecalRightPanel from "./TariffItemCopyForRecalRightPanel";

const ProposalCopyingForRecalItemRightPanel = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const { isShowCopyToCompanyPanel, isShowEditPanel, isShowTariffItemTierPanel } = proposalCopyingForRecalState;

    return <>
        <div className={`main-comp-wrapper${(isShowCopyToCompanyPanel || isShowEditPanel || isShowTariffItemTierPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={(isShowCopyToCompanyPanel || isShowEditPanel || isShowTariffItemTierPanel) ? "35%" : "100%"}
                rightSectionWidth={(isShowCopyToCompanyPanel || isShowEditPanel || isShowTariffItemTierPanel) ? "65%" : "0%"}
                leftChildren={<ProposalCopyingForRecalTariffItemTablePanel />}
                rightChildren={isShowCopyToCompanyPanel ? <TariffItemCopyForRecalRightPanel /> : ((isShowEditPanel || isShowTariffItemTierPanel) ? <TariffItemTierForRecalTablePanel /> : <></>)}
            />
        </div>
    </>
}

export default ProposalCopyingForRecalItemRightPanel;
